import { Component, OnInit, EventEmitter, Input, Output, inject } from '@angular/core';
import { Upload } from 'app/core/models/upload.model';
import { ThirdPartyAdminister } from 'app/core/models/third-party-administer.model';
import { ThirdPartyAdministersService } from 'app/core/services/third-party-administers.service';
import { FormsModule } from '@angular/forms';
import { FileUploadComponent } from '../../../shared/components/file-upload/file-upload.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { ClientSelectComponent } from '../../../shared/components/client-select/client-select.component';

const emptyForm = { clientId: null, thirdPartyAdministerId: '', name: '', file: null };

export class ImportUploadResult {
  clientId?: number;
  thirdPartyAdministerId?: number;
  name?: string;
  upload: Upload;
}

@Component({
    selector: 'app-icc-import-upload',
    templateUrl: './icc-import-upload.component.html',
    imports: [FormsModule, ClientSelectComponent, FileUploadComponent, FaIconComponent]
})
export class IccImportUploadComponent implements OnInit {
  private thirdPartyAdministersService = inject(ThirdPartyAdministersService);

  @Input() collectThirdPartyAdminister = false;
  @Input() collectClient = true;

  @Output() uploadComplete = new EventEmitter<ImportUploadResult>();
  @Output() uploadStart = new EventEmitter();

  uploading = false;
  formModel: { clientId: number | null; thirdPartyAdministerId: string; name: string; file: any } = { ...emptyForm };
  thirdPartyAdministers: ThirdPartyAdminister[] = [];

  ngOnInit() {
    if (this.collectThirdPartyAdminister) {
      this.loadThirdPartyAdministers();
    }
  }

  onUploadStart() {
    this.uploading = true;
    this.uploadStart.emit();
  }

  onUploadCancel() {
    this.uploading = false;
  }

  onUploadComplete(upload: Upload) {
    this.uploading = false;

    const result: ImportUploadResult = {
      upload,
      name: this.formModel.name,
    };

    if (this.collectClient) {
      result.clientId = this.formModel.clientId;
    }

    if (this.collectThirdPartyAdminister) {
      result.thirdPartyAdministerId = parseInt(this.formModel.thirdPartyAdministerId, 10);
    }

    this.uploadComplete.emit(result);
  }

  onUploadError() {
    this.uploading = false;
  }

  onFormEnter($event) {
    $event.preventDefault();
  }

  get uploadButtonDisabled(): boolean {
    return !(
      (!this.collectClient || this.formModel.clientId) &&
      (!this.collectThirdPartyAdminister || this.formModel.thirdPartyAdministerId) &&
      this.formModel.file
    );
  }

  loadThirdPartyAdministers() {
    this.thirdPartyAdministersService.getList().subscribe(result => {
      this.thirdPartyAdministers = result.thirdPartyAdministers;
    });
  }

  onFileSelected(file) {
    this.formModel.file = file;
  }
}
